import { PermissionList, PermissionDialog } from "@/features/permission";
import {
  SystemRoleList,
  SystemRoleDrawer,
  DeleteRoleDialog,
} from "@/features/systemRole";

export default function RolePermissionsPage() {
  return (
    <div className="flex h-full flex-col p-4 bg-slate-50/50">
      <div className="mb-4">
        <h1 className="text-xl font-bold text-gray-900">권한·역할 관리</h1>
        <p className="mt-0.5 text-xs text-gray-600">
          시스템 권한 카탈로그와 베이스라인 역할을 관리합니다. 역할 변경은 모든 배차 업체에 자동 동기화됩니다.
        </p>
      </div>

      <div className="grid flex-1 min-h-0 grid-cols-1 gap-4 lg:grid-cols-[2fr_3fr]">
        <PermissionList />
        <SystemRoleList />
      </div>

      <PermissionDialog />
      <SystemRoleDrawer />
      <DeleteRoleDialog />
    </div>
  );
}
